import { KYMW1308Model } from '../kymw1308.model';
import { KYMW1308RegistPromotionGoodsModel } from '../vo/kymw1308-regist-promotion-goods.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　プロモーション商品情報を登録するサービス
 *
 * @export RegistPromotionGoodsService
 * @class RegistPromotionGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistPromotionGoodsService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1308Model}
   * @memberof RegistPromotionGoodsService
   */
  private model: KYMW1308Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1308RegistPromotionGoodsModel}
   * @memberof RegistPromotionGoodsService
   */
  private vo: KYMW1308RegistPromotionGoodsModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPromotionGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        PromotionGoods: {
          condition: {
            PromotionNo: this.vo.promotionNo,
            PromotionName: this.vo.promotionName,
            PromotionDiv: this.vo.promotionDiv,
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
          },
          combination: this.vo.registGoodsList.map(obj => {
            return {
              condition: {
                PCode: obj.pCode,
                CoopCode: obj.coopCode,
                ApprovedNum: obj.approvedNum,
                ApprovedPrice: obj.approvedPrice,
                WakuwakuPoint: obj.wakuwakuPoint
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof RegistPromotionGoodsService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1308Model>model;
    this.vo = vo;
    this.send('registPromotionGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPromotionGoodsService
   */
  success(data: any): void {
    // 呼出元画面の再表示を行う
    this.model.KYMW1308Component.refleshKYMW1300();
    // プロモーションＮＯ再取得
    this.model.KYMW1308Component.refleshPromotionNo();
  }
}
